(function () {
  'use strict';

  if (!document.getElementById('vhWrap')) return;

  /* ════════════════════════════════════════
     HAMPER CONFIG
  ════════════════════════════════════════ */
  var HAMPERS = {
    'noir-petite': {
      name: 'VOCCA Noir Petite',
      size: 'Small',
      price: 145,
      emoji: '🍫',
      categories: [
        { id: 'chocolate-bar-125g', label: 'Chocolate Bar - 125gms', qty: 1 },
        { id: 'ivory',             label: 'Ivory',                   qty: 6 },
        { id: 'drops',             label: 'Drops',                   qty: 1 }
      ]
    },
    'maison-elite': {
      name: 'VOCCA Maison Élite',
      size: 'Medium',
      price: 235,
      emoji: '🎁',
      categories: [
        { id: 'chocolate-bar-125g', label: 'Chocolate Bar - 125gms', qty: 1 },
        { id: 'ivory',              label: 'Ivory',                   qty: 6 },
        { id: 'drops',              label: 'Drops',                   qty: 1 },
        { id: 'bark',               label: 'Bark',                    qty: 1 },
        { id: 'chewy-cookie',       label: 'Chewy Cookie',            qty: 1 }
      ]
    },
    'imperial-reserve': {
      name: 'VOCCA Imperial Reserve',
      size: 'Large',
      price: 345,
      emoji: '👑',
      categories: [
        { id: 'chocolate-bar-125g', label: 'Chocolate Bar - 125gms', qty: 3 },
        { id: 'chocolate-box',      label: 'Chocolate Box',           qty: 1 },
        { id: 'drops',              label: 'Drops',                   qty: 3 },
        { id: 'bark',               label: 'Bark',                    qty: 1 },
        { id: 'chewy-cookie',       label: 'Chewy Cookie',            qty: 1 },
        { id: 'kunafa-gift-set',    label: 'Kunafa Gift Set',         qty: 1 }
      ]
    }
  };

  /* ════════════════════════════════════════
     STATE
  ════════════════════════════════════════ */
  var state = {
    hamper: null,          // key from HAMPERS
    catIndex: 0,           // current category index (0 = first category, cats.length = card step)
    selections: {},        // { catId: [{id, title, ...}] }
    card: {
      include: false,
      occasion: '',
      to: '',
      from: '',
      message: ''
    }
  };

  /* ════════════════════════════════════════
     DOM REFS
  ════════════════════════════════════════ */
  var landing      = document.getElementById('vhLanding');
  var popup        = document.getElementById('vhPopup');
  var builder      = document.getElementById('vhBuilder');
  var popupName    = document.getElementById('vhPopupName');
  var popupPrice   = document.getElementById('vhPopupPrice');
  var popupImg     = document.getElementById('vhPopupImg');
  var popupIncludes = document.getElementById('vhPopupIncludes');
  var summaryName  = document.getElementById('vhSummaryName');
  var summaryPrice = document.getElementById('vhSummaryPrice');
  var summaryCats  = document.getElementById('vhSummaryCats');
  var catName      = document.getElementById('vhCatName');
  var catProgress  = document.getElementById('vhCatProgress');
  var productGrid  = document.getElementById('vhProductGrid');
  var cardStep     = document.getElementById('vhCardStep');
  var navBack      = document.getElementById('vhNavBack');
  var navNext      = document.getElementById('vhNavNext');
  var atcBtn       = document.getElementById('vhAtcBtn');
  var cardYes      = document.getElementById('vhCardYes');
  var cardNo       = document.getElementById('vhCardNo');
  var cardFields   = document.getElementById('vhCardFields');
  var cardOccasion = document.getElementById('vhCardOccasion');
  var cardTo       = document.getElementById('vhCardTo');
  var cardFrom     = document.getElementById('vhCardFrom');
  var cardMsg      = document.getElementById('vhCardMsg');
  var cardMsgCount = document.getElementById('vhCardMsgCount');

  /* ════════════════════════════════════════
     HAMPER CARD SELECT BUTTONS
  ════════════════════════════════════════ */
  document.querySelectorAll('.vh-card__select').forEach(function (btn) {
    btn.addEventListener('click', function () {
      openPopup(this.dataset.hamper);
    });
  });

  function openPopup(hamperKey) {
    var h = HAMPERS[hamperKey];
    if (!h) return;
    state.hamper = hamperKey;

    popupName.textContent  = h.name;
    popupPrice.textContent = 'د.إ ' + h.price;
    popupImg.textContent   = h.emoji;

    popupIncludes.innerHTML = h.categories.map(function (c) {
      return '<li>' + c.qty + ' × ' + c.label + '</li>';
    }).join('');

    popup.classList.add('is-open');
  }

  document.getElementById('vhPopupClose').addEventListener('click', closePopup);
  document.getElementById('vhPopupBack').addEventListener('click', closePopup);
  popup.addEventListener('click', function (e) {
    if (e.target === popup) closePopup();
  });

  function closePopup() {
    popup.classList.remove('is-open');
    state.hamper = null;
  }

  /* ════════════════════════════════════════
     START BUILDING
  ════════════════════════════════════════ */
  document.getElementById('vhPopupStart').addEventListener('click', function () {
    popup.classList.remove('is-open');
    startBuilder();
  });

  function startBuilder() {
    var h = HAMPERS[state.hamper];
    if (!h) return;

    // Reset state
    state.catIndex = 0;
    state.selections = {};
    state.card = { include: false, occasion: '', to: '', from: '', message: '' };

    // Update summary header
    summaryName.textContent  = h.name;
    summaryPrice.textContent = 'د.إ ' + h.price;

    // Hide landing, show builder
    landing.style.display = 'none';
    builder.classList.add('is-active');

    renderSummaryCats();
    renderCurrentCat();
    updateAtcBtn();

    // Scroll to top of builder
    builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ════════════════════════════════════════
     SUMMARY PANEL
  ════════════════════════════════════════ */
  function renderSummaryCats() {
    var h = HAMPERS[state.hamper];
    var html = '';
    h.categories.forEach(function (cat, i) {
      var sel = state.selections[cat.id] || [];
      var done = sel.length >= cat.qty;
      var current = (i === state.catIndex);
      html += '<div class="vh-summary__cat' +
              (current ? ' is-current' : '') +
              (done    ? ' is-done'    : '') +
              '" data-cat-index="' + i + '">' +
              '<span class="vh-summary__cat-name">' + cat.label + '</span>' +
              '<span class="vh-summary__cat-count">' + (done ? '✓' : sel.length + '/' + cat.qty) + '</span>' +
              '</div>';
    });
    // Card step
    var cardCurrent = (state.catIndex === h.categories.length);
    html += '<div class="vh-summary__cat' + (cardCurrent ? ' is-current' : '') + '">' +
            '<span class="vh-summary__cat-name">Personalized Card</span>' +
            '<span class="vh-summary__cat-count">Optional</span></div>';

    summaryCats.innerHTML = html;

    // Click to jump to category
    summaryCats.querySelectorAll('[data-cat-index]').forEach(function (el) {
      el.addEventListener('click', function () {
        var idx = parseInt(this.dataset.catIndex);
        state.catIndex = idx;
        renderSummaryCats();
        renderCurrentCat();
      });
    });
  }

  /* ════════════════════════════════════════
     CATEGORY PANEL
  ════════════════════════════════════════ */
  function renderCurrentCat() {
    var h = HAMPERS[state.hamper];
    var isCardStep = (state.catIndex >= h.categories.length);

    productGrid.style.display = isCardStep ? 'none' : 'grid';
    cardStep.style.display    = isCardStep ? 'block' : 'none';

    if (isCardStep) {
      catName.textContent    = 'Personalized Card';
      catProgress.innerHTML  = 'Add a personal touch — <strong>optional</strong>';
      navNext.textContent    = 'Add to Cart →';
      navNext.disabled       = false;
      atcBtn.disabled        = false;
      updateAtcBtn();
      return;
    }

    var cat = h.categories[state.catIndex];
    var sel = state.selections[cat.id] || [];

    catName.textContent   = cat.label;
    catProgress.innerHTML = 'Selected: <strong>' + sel.length + ' / ' + cat.qty + '</strong>';
    navNext.textContent   = (state.catIndex < h.categories.length - 1) ? 'Next →' : 'Continue →';
    navNext.disabled      = (sel.length < cat.qty);

    renderProductGrid(cat);
  }

  function renderProductGrid(cat) {
    var products = (window.vhProducts && window.vhProducts[cat.id]) || [];
    var sel = state.selections[cat.id] || [];
    var maxReached = sel.length >= cat.qty;

    if (!products.length) {
      productGrid.innerHTML = '<div style="grid-column:1/-1;padding:40px;text-align:center;color:#7a6558;">No products found for this category.<br><small>Please contact VOCCA to configure this selection.</small></div>';
      return;
    }

    productGrid.innerHTML = products.map(function (p) {
      var count = sel.filter(function (s) { return s.id === p.id; }).length;
      var selected = count > 0;
      var canAdd = !maxReached || selected; // can still remove if selected

      var imgHtml = p.img
        ? '<img class="vh-product-card__img" src="' + p.img + '" alt="" loading="lazy">'
        : '<div class="vh-product-card__img-ph">🍫</div>';

      return '<div class="vh-product-card' + (selected ? ' is-selected' : '') + '" data-product-id="' + p.id + '">' +
             '<div class="vh-product-card__selected-check">✓</div>' +
             imgHtml +
             '<div class="vh-product-card__info">' +
             '<p class="vh-product-card__title">' + (p.title || '') + '</p>' +
             '<div class="vh-product-card__footer">' +
             '<span class="vh-product-card__count">' + (count > 0 ? count : '0') + '</span>' +
             '<button class="vh-product-card__add" data-product-id="' + p.id + '" data-cat="' + cat.id + '"' + (!canAdd && !selected ? ' disabled' : '') + '>+</button>' +
             '</div></div></div>';
    }).join('');

    // Add button handlers
    productGrid.querySelectorAll('.vh-product-card__add').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var pid  = parseInt(this.dataset.productId);
        var cid  = this.dataset.cat;
        var h    = HAMPERS[state.hamper];
        var catConf = h.categories.find(function (c) { return c.id === cid; });
        var maxQ = catConf ? catConf.qty : 1;

        if (!state.selections[cid]) state.selections[cid] = [];
        var sel = state.selections[cid];
        var existing = sel.filter(function (s) { return s.id === pid; }).length;

        if (existing < maxQ && sel.length < maxQ) {
          var prod = (window.vhProducts[cid] || []).find(function (p) { return p.id === pid; });
          if (prod) sel.push(prod);
        }

        renderSummaryCats();
        renderCurrentCat();
        updateAtcBtn();
      });
    });

    // Click on card to toggle (remove if selected, add if not)
    productGrid.querySelectorAll('.vh-product-card').forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('.vh-product-card__add')) return;
        var pid = parseInt(this.dataset.productId);
        var cid = cat.id;
        if (!state.selections[cid]) state.selections[cid] = [];
        var sel = state.selections[cid];
        var idx = sel.findIndex(function (s) { return s.id === pid; });
        if (idx !== -1) {
          sel.splice(idx, 1); // remove one instance
        } else {
          if (sel.length < cat.qty) {
            var prod = (window.vhProducts[cid] || []).find(function (p) { return p.id === pid; });
            if (prod) sel.push(prod);
          }
        }
        renderSummaryCats();
        renderCurrentCat();
        updateAtcBtn();
      });
    });
  }

  /* ════════════════════════════════════════
     NAVIGATION
  ════════════════════════════════════════ */
  navNext.addEventListener('click', function () {
    var h = HAMPERS[state.hamper];
    var isCardStep = (state.catIndex >= h.categories.length);

    if (isCardStep) {
      submitHamper();
      return;
    }
    state.catIndex++;
    renderSummaryCats();
    renderCurrentCat();
  });

  navBack.addEventListener('click', function () {
    if (state.catIndex === 0) {
      // Return to landing
      builder.classList.remove('is-active');
      landing.style.display = '';
      return;
    }
    state.catIndex--;
    renderSummaryCats();
    renderCurrentCat();
  });

  atcBtn.addEventListener('click', function () {
    submitHamper();
  });

  function updateAtcBtn() {
    if (!state.hamper) { atcBtn.disabled = true; return; }
    var h = HAMPERS[state.hamper];
    var allDone = h.categories.every(function (cat) {
      return (state.selections[cat.id] || []).length >= cat.qty;
    });
    atcBtn.disabled = !allDone;
  }

  /* ════════════════════════════════════════
     PERSONALIZED CARD STEP
  ════════════════════════════════════════ */
  cardYes.addEventListener('click', function () {
    state.card.include = true;
    cardYes.classList.add('is-selected');
    cardNo.classList.remove('is-selected');
    cardFields.classList.add('is-visible');
  });
  cardNo.addEventListener('click', function () {
    state.card.include = false;
    cardNo.classList.add('is-selected');
    cardYes.classList.remove('is-selected');
    cardFields.classList.remove('is-visible');
  });

  cardMsg.addEventListener('input', function () {
    var l = this.value.length;
    cardMsgCount.textContent = l;
    state.card.message = this.value;
  });

  /* ════════════════════════════════════════
     ADD TO CART
  ════════════════════════════════════════ */
  function submitHamper() {
    var h = HAMPERS[state.hamper];
    if (!h) return;

    // Sync card fields
    if (state.card.include) {
      state.card.occasion = cardOccasion.value;
      state.card.to       = cardTo.value.trim();
      state.card.from     = cardFrom.value.trim();
      state.card.message  = cardMsg.value.trim();
    }

    // Build line item properties
    var props = {
      'Hamper': h.name,
      'Hamper Size': h.size
    };

    // Add all selected products
    h.categories.forEach(function (cat) {
      var sel = state.selections[cat.id] || [];
      sel.forEach(function (p, i) {
        var key = sel.length > 1
          ? cat.label + ' ' + (i + 1)
          : cat.label;
        props[key] = p.title;
      });
    });

    // Personalized card
    if (state.card.include) {
      props['Personalized Card'] = 'Yes';
      if (state.card.occasion) props['Card Occasion'] = state.card.occasion;
      if (state.card.to)       props['Card To']       = state.card.to;
      if (state.card.from)     props['Card From']     = state.card.from;
      if (state.card.message)  props['Card Message']  = state.card.message;
    } else {
      props['Personalized Card'] = 'No';
    }

    // Get variant ID
    var variantId = (window.vhVariants && window.vhVariants[state.hamper]) || '';

    if (!variantId) {
      // Fallback: try fetching from product JSON
      fetch('/products/vocca-' + state.hamper + '.json')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d.product && d.product.variants.length) {
            addHamperToCart(d.product.variants[0].id, props, h);
          } else {
            alert('Hamper product not found. Please contact VOCCA.');
          }
        })
        .catch(function () {
          alert('Could not find hamper product. Please ensure vocca-' + state.hamper + ' is published in Shopify.');
        });
      return;
    }

    addHamperToCart(parseInt(variantId), props, h);
  }

  function addHamperToCart(variantId, props, h) {
    atcBtn.disabled  = true;
    atcBtn.textContent = 'Adding…';
    navNext.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: props
      })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status && data.status !== 200) throw new Error(data.description || 'Error');
      window.location.href = '/cart';
    })
    .catch(function (err) {
      console.error('[VOCCA HAMPER]', err);
      alert('Could not add hamper to cart: ' + (err.message || 'Please try again.'));
      atcBtn.disabled    = false;
      atcBtn.textContent = 'Add Customized Hamper to Cart';
      navNext.disabled   = false;
    });
  }

})();
